import { connectHook } from 'app/common/components/connect-hook';
import { BranchSwitcher } from './branch-switcher.js';
import { useBranchSwitcher } from './branch-switcher-hook.js';

export default connectHook(BranchSwitcher, useBranchSwitcher);
